@if (icon) {
  <img alt="locator" class="position-relative" height="60" ngSrc="{{icon}}" width="50">
}
